
import swal from "sweetalert";
declare var jQuery:any;
declare var lms_single_page_product:any;

/*
const applyBackBtnBehavior = () => {
    if(jQuery('.product_event_session_member_pricing').length > 0) {
        const backBtnExists = jQuery('.product_event_session_member_pricing .backbtn').length > 0;
        if (!backBtnExists) {
            jQuery(".product_event_session_member_pricing .backbtn").on('click', function (event:any) {
                jQuery('.product_event_session_list').show();
                jQuery('.product_event_session_member_pricing').html('');
                jQuery('#addToCartSideNav .backbtn').hide();
                jQuery('.custom_add_to_cart_button .temp_spinner').hide();
                jQuery('.session_picker_slot.purchasable .custom_add_to_cart_button').removeAttr('disabled');
                jQuery('.session-checkbox-single-product-page').prop('checked', false);
                jQuery(main_add_to_cart_btn).hide();
            });
        }
    }

    jQuery('#addToCartSideNav .backbtn').on('click', function (event:any) {
        jQuery('.session-checkbox-single-product-page').prop('checked', false);
        jQuery(main_add_to_cart_btn).hide();

        const session_amount = jQuery('.session_picker_slot').length;
        if ( session_amount > 0 ){
            jQuery('.product_event_session_list').show();
            jQuery('.product_event_session_member_pricing').html('');
            jQuery('#addToCartSideNav .backbtn').hide();
            //uncheck all checboxes [button-role=view-pricing-button]
            // jQuery('[button-role=view-pricing-button').prop('checked', false);

            //Return the add to cart button to the default product to avoid bugs and edge cases (this way the error messages will be ok, because the system is used to handle the main product add to cart)
            const product_id = jQuery('.load-add-to-cart').val()
        } else {
            // jQuery('[name=add-to-cart]:not(.load-add-to-cart)').show();
        }
    });
}

const setBehaviorForChoosePriceBtns = () => {
    // ========= Choose price btn
    jQuery(choose_price_btn).on('click', function (event:any) {
        const purchasable = !jQuery(this).hasClass('not-purchasable');
        if(!purchasable){
            return;
        }

        // updateAddMultipleSessionToCartButton();

        const session_slot_el = jQuery(this).closest('.session_picker_slot');

        // Checks / Unchecks the selected checbox
        var checkbox = jQuery(session_slot_el).find('.session-checkbox-single-product-page')

        jQuery(checkbox).prop('checked', true);

        jQuery('.product_event_session_list').hide();
        jQuery('.product_event_session_member_pricing').show();
        jQuery('#addToCartSideNav .backbtn').show();

        const session_post_id = jQuery(session_slot_el).attr('session-post-id');
        const session_item_id = jQuery(session_slot_el).attr('session-item-id');
        console.log(session_item_id)
        const prices = Object.values(JSON.parse(jQuery(session_slot_el).attr('data-price-data')));
        
        var sorted_prices:any = prices
            .filter((item:any) => item.member_role)
            .sort((a:any, b:any) => b.raw_value - a.raw_value);
        
        var general_price = prices.filter((item:any) => !item.member_role);
        if(general_price.length > 0){
            sorted_prices.push(general_price[0]);
        }
        sorted_prices.reverse();
        console.log(sorted_prices);

        const prices_acessible = sorted_prices.filter((item:any) => item.current_user_has_access);
        const bestPrice = Math.min(...prices_acessible.map((item:any) => item.raw_value));

        const member_pricing_exists = jQuery(`.product_event_session_member_pricing .pricing_session_${session_post_id}`).length > 0;
        if(!member_pricing_exists){
            jQuery('.product_event_session_member_pricing').append(
                `<ul class='member-pricing-table product_event_session_list pricing_session_${session_post_id}' style='width: 100%'>` +
                    sorted_prices.map((value:any) => {
                        
                        const checked = 
                            (((value.raw_value == bestPrice) && value['current_user_has_access']) && lms_single_page_product.enforce_cheapest_available_price)
                            ? 'checked' : '';
// debugger
                        const html = (
                            `<li session-post-id="${session_post_id}" class="${ (checked) ? 'bestprice' : ''}" title="${ (checked) ? 'Best available price' : ''}" >
                                <div class="description">
                                    <span class="checkbox"> 
                                        ${ (value["current_user_has_access"]) ? 
                                            `<input type="radio" class="member_price" name="selected_session_price_selected[${session_item_id}]" value="` + (value['member_role'] ? value['member_role'] : '') + '">' 
                                            : ''
                                        }
                                    </span>
                                    <span class="title"> ${value['role']} </span>
                                </div>
                                <div>
                                    <div class="price"> <h4> ${value['parsed'].replace('&#36;', '$') } <h4> </div>
                                </div>
                            </li>`
                        );

                        return html;

                    }).join('') +
                "</ul>"
            );
        }
        jQuery(`.member-pricing-table.product_event_session_list.pricing_session_${session_post_id}`).show();        

        // updateAddMultipleSessionToCartButton();

        jQuery('.member-pricing-table li').on('click', function (event:any) {
            jQuery(this).find('input.member_price').prop('checked', true);
            //register the selected price
            var price_role = jQuery(this).find('[name=_member_role]').val();
            var session_post_id = jQuery(this).attr('session-post-id')
            jQuery(`.session-checkbox-single-product-page[data-post-id=${session_post_id}]`).prop('checked', true);
            var element = jQuery(`.session_picker_slot[session-post-id=${session_post_id}] .selected_session_price`);
            jQuery(element).val(price_role);
        });

        jQuery('.member-pricing-table [name=_member_role]').on('change', function (event:any) {
            jQuery(main_add_to_cart_btn).removeAttr('disabled');
        });

        applyBackBtnBehavior();

        jQuery(main_add_to_cart_btn).show();
    });
}

const setBehaviorForCustomAddToCartButtons = () => {
    // jQuery('.custom_add_to_cart_button').on('click', function (event:any) {
    //     const trueAddToCart = jQuery('[name=add-to-cart]:not(.load-add-to-cart)');
    //     const session_post_id = jQuery(this).val();
    //     // jQuery(trueAddToCart).val(session_post_id).click().disable();

    //     //Add spinner to the button
    //     toggleSpinnerOnButton(this, true);
    // });

    jQuery(session_add_to_cart_btn).on('click', function (event:any) {        
        jQuery(choose_price_btn).attr('disabled', 'disabled');
        jQuery(session_add_to_cart_btn).attr('disabled', 'disabled');        

        // disable all optional checkboxes
        jQuery('.session-checkbox-single-product-page').prop('checked', false);
        // enable the clicked checkbox
        jQuery(this).parents('.session_picker_slot').find('.session-checkbox-single-product-page').prop('checked', true);

        //Executes add to cart
        jQuery(main_add_to_cart_btn).removeAttr('disabled').show().click().hide();
        toggleSpinnerOnButton(this, true);

        //Disables all other add to cart buttons
        jQuery([session_add_to_cart_btn, choose_price_btn]).attr('disabled', 'disabled');
    });
}

const setUpSideBarBehavior = () => {
    jQuery( "#addToCartSideNav" ).on('ajax_reloaded', () => {
        const session_amount = jQuery('.session_picker_slot').length;
        // if ( session_amount > 0 ){        
        //     jQuery('[name=add-to-cart]:not(.load-add-to-cart)').hide();
        // } else {
        //     jQuery('[name=add-to-cart]:not(.load-add-to-cart)').show();
        // }
        setBehaviorForChoosePriceBtns();

        jQuery('#addToCartSideNav .backbtn').hide();

        // jQuery('.member-pricing-table [name=_member_price_url]').on('change', function (event:any) {
        //     jQuery('[name=add-to-cart]:not(.load-add-to-cart)').removeAttr('disabled');
        // });
        
        //Session click handler
        jQuery('.member_prices li').on('click', function (event:any) {
            const input = jQuery(this).find('[name=_member_price_url]');
            const is_disabled = jQuery(input).prop('disabled');
            if(!is_disabled){
                jQuery(this).find('[name=_member_price_url]').prop('checked', true);
                // jQuery('[name=add-to-cart]:not(.load-add-to-cart)').removeAttr('disabled');
            }
        });
        //Member price click handler
        jQuery('#pricing_table tr').off('click').on('click', function (event:any) {
            if(!jQuery(this).find('[name=_member_price_url]').prop('disabled')){
                jQuery(this).find('[name=_member_price_url]').prop('checked', true);
                // jQuery('[name=add-to-cart]:not(.load-add-to-cart)').removeAttr('disabled');
            }
        });

        jQuery( "#addToCartSideNav [name=add-to-cart]").on('click', function(e:any) {
            toggleSpinnerOnButton(this);
        });

        setBehaviorForCustomAddToCartButtons();
        setBehaviorForMainAddToCartButtons();

        jQuery(main_add_to_cart_btn).hide();
    });
}

const setBehaviorForMainAddToCartButtons = () => {
    // ========= Main add to cart btn    
    jQuery(main_add_to_cart_btn).off('click').on('click', function (event:any) {
        toggleSpinnerOnButton(this, true);
        jQuery(choose_price_btn).attr('disabled', 'disabled');
        jQuery(session_add_to_cart_btn).attr('disabled', 'disabled');
    });
}*/

//START - Membership composite
const MC_hideAllMinusPlusIfAny = () => {
    // Select all elements with the class 'wooco_component_product_qty_minus' and 'wooco_component_product_qty_plus'
    const minusButtons = document.querySelectorAll('.wooco_component_product_qty_minus.wooco-minus');
    const plusButtons = document.querySelectorAll('.wooco_component_product_qty_plus.wooco-plus');

    // Hide all minus buttons
    minusButtons.forEach(button => {
        (button as HTMLElement).style.display = 'none';
    });

    // Hide all plus buttons
    plusButtons.forEach(button => {
        (button as HTMLElement).style.display = 'none';
    });
}
//END - Membership composite

//Click events
jQuery(document).ready(function () {
    if(jQuery('#addToCartSideNav'))
        jQuery('body').append(jQuery('#addToCartSideNav'));

    MC_hideAllMinusPlusIfAny();
});

// ================================================================================================